import { ApiServiceV1 } from '@services';

export const PrintProvidersApiService = {
  async getAvailableOperations({ suffix, vendor }) {
    const { data } = await ApiServiceV1.get(`${suffix}/plugin/${vendor}/operations`);

    return data || [];
  },
};

export default {};
